import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import logo from "../../assets/logo-main.webp";
import styles from "./index.module.css";
import { getLatestReleaseUrl } from "./getLatestReleaseUrl";

const TopNavigation = () => {
  const [showMobNav, setShowMobNav] = useState(false);

  const handleDownload = async () => {
    try {
      const url = await getLatestReleaseUrl();
      console.log(url);
      const link = document.createElement("a");
      link.href = url;
      link.download = url.split("/").pop() || "Epinics-POS-Setup.exe";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch {
      alert("Failed to fetch the latest installer. Please try again later.");
    }
  };

  return (
    <div className={styles.topNavContainer}>
      <div
        className={`${styles.mobNav} ${showMobNav ? styles.mobNavShow : ""}`}
      >
        <div className={styles.logoDiv}>
          <div className={styles.left}>
            <img className={styles.logo} src={logo} alt="logo" loading="lazy" />
            <div className={styles.name}>EPINICS</div>
          </div>
          <div className={styles.right}>
            <IoClose onClick={() => setShowMobNav(false)} />
          </div>
        </div>
        {[
          "HOME",
          "INFO",
          "FEATURES",
          "PRICING",
          "CONTACT",
          "FAQ",
          "DOWNLOAD",
        ].map((link, index) => {
          // define href based on link type
          let href = `#${link.toLowerCase()}`;

          if (link === "CONTACT") {
            href = "/contact";
          } else if (link === "DOWNLOAD") {
            href = "#"; // prevent default navigation for download
          }

          return (
            <a
              key={index}
              href={href}
              onClick={e => {
                if (link === "DOWNLOAD") {
                  e.preventDefault(); // stop anchor from navigating
                  handleDownload(); // ✅ trigger your download function
                }
                setShowMobNav(false); // close mobile nav on any click
              }}
            >
              <div className={styles.mobNavLink}>{link}</div>
            </a>
          );
        })}
      </div>
      <div className={styles.burgerIconDiv}>
        <RxHamburgerMenu
          className={styles.burgerIcon}
          onClick={() => setShowMobNav(!showMobNav)}
        />
      </div>
      <div className={styles.navLinkContainer}>
        {[
          "HOME",
          "INFO",
          "FEATURES",
          "PRICING",
          "CONTACT",
          "FAQ",
          "DOWNLOAD",
        ].map((link, index) => (
          <div
            key={index}
            className={styles.navLink}
            onClick={() => {
              if (link === "CONTACT") {
                window.location.href = "/contact";
              } else if (link === "DOWNLOAD") {
                handleDownload();
              } else {
                window.location.href = `#${link.toLowerCase()}`;
              }
            }}
          >
            {link}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopNavigation;
